import type { ResumeData } from "@izicvs/schema";
import { useMutation } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

export type GeneratedResume = { data: ResumeData; title: string };

export const useGenerateResume = () => {
  const {
    mutateAsync: generate,
    isPending: loading,
    error,
  } = useMutation({
    mutationFn: async (payload: { input: string; language?: string }) => {
      const response = await axios.post<GeneratedResume>("/ai/generate-resume", payload);
      return response.data;
    },
  });

  return { generate, loading, error };
};
